'use strict';

var _ = require('lodash');
var d3 = require('d3');
var RomSummaryOpportunityTrendsScales = function RomSummaryOpportunityTrendsScales(params, data, range) {
  var yMaxRevOpp = d3.max(data, function (d) {
    return d.revOpp;
  });
  var yMin = d3.min(data, function (d) {
    return Math.min(d.spill, d.recapture);
  });
  var yMax = d3.max(data, function (d) {
    return d.isHidden ? 0 : Math.max(d.spill, d.recapture);
  });
  yMin = yMin ? Math.min(yMin, 0) : 0;
  yMax = yMax ? Math.max(yMax, 0, -yMin * 0.7) : 0;
  yMaxRevOpp = yMaxRevOpp || 0;
  var yScaleRight = d3.scale.linear().domain([yMaxRevOpp === 0 || yMax === 0 ? 0 : yMin / yMax * yMaxRevOpp, yMaxRevOpp]).rangeRound([params.height, 0]);
  var y = d3.scale.linear().domain([yMin, yMax]).rangeRound([params.height, 0]);
  if (range) {
    data = data.slice(range[0], range[1]);
  }
  function calculateWidth() {
    var width = params.width;
    var dataLength = data.length;
    if (params.width / dataLength > params.maxGroupWidth) {
      width = params.maxGroupWidth * dataLength;
    }
    return width;
  }
  var width, offset;
  if (params.maxGroupWidth) {
    width = calculateWidth();
    offset = (params.width - width) / 2;
  } else {
    width = params.width;
    offset = 0;
  }
  var x = d3.scale.ordinal().domain(_.map(data, 'dimension')).rangeBands([offset, width + offset], 0.2, 0.1);
  return {
    xScale: x,
    yScale: y,
    yScaleRight: yScaleRight
  };
};
RomSummaryOpportunityTrendsScales.$inject = [];
module.exports = RomSummaryOpportunityTrendsScales;